<template>
  <div>
    <PageHead title="取暖费报销列表"></PageHead>
    <div class="oa-layout-content">
      <div class="search-flex">
        <div class="query-top-select">
          <div class="query-cont">
            <div class="query-view">
              <div class="query-view-lable">申请人：</div>
              <a-input
                allowClear
                class="w200"
                placeholder="请输入申请人"
                v-model="queryForm.assetsname"
              />
            </div>
            <div class="query-view">
              <div class="query-view-lable">申请时间：</div>
              <a-date-picker
                show-time
                class="w200"
                valueFormat="YYYY-MM-DD HH:mm:ss"
                v-model="queryForm.birthTime"
              />
            </div>
            <div class="query-view">
              <div class="query-view-lable">表单状态：</div>
              <a-select
                allowClear
                placeholder="不限"
                class="w200"
                v-model="queryForm.state"
              >
                <a-select-option :value="0">待提交</a-select-option>
                <a-select-option :value="1">正在审批</a-select-option>
                <a-select-option :value="2">已归档</a-select-option>
                <a-select-option :value="3">退回</a-select-option>
                <!-- <a-select-option :value="4">取消</a-select-option> -->
              </a-select>
            </div>
          </div>
        </div>
        <div class="search-flex-itemm">
          <a-button type="primary" @click="subMit" :loading="loading">
            查询</a-button
          >
          <a-button :style="{ marginLeft: '8px' }" @click="cancel()">
            取消
          </a-button>
        </div>
      </div>

      <div class="mb20 search-btns mt20">
        <a-button type="primary" @click="add()" icon="plus"> 申请</a-button>
        <span class="statistics"> 检索统计： {{ total }} 条 </span>
      </div>
      <a-table
        :pagination="false"
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="(record) => record.id"
      >
        <span slot="index" slot-scope="text, record, index">
          {{ index + 1 + (page - 1) * 10 }}
        </span>
        <span slot="disposalstate" slot-scope="text">{{ text }}</span>
        <div slot="state" class="statusDiv" slot-scope="text">
          <div v-if="text == 0" class="dot0 mr5"></div>
          <div v-if="text == 1" class="dot1 mr5"></div>
          <div v-if="text == 2" class="dot2 mr5"></div>
          <div v-if="text == 3" class="dot3 mr5"></div>
          <div v-if="text == 4" class="dot4 mr5"></div>
          <span v-if="text == 0"> 待提交 </span>
          <span v-if="text == 1"> 正在审批 </span>
          <span v-if="text == 2"> 已归档 </span>
          <span v-if="text == 3"> 退回 </span>
          <span v-if="text == 4"> 取消 </span>
        </div>
        <div slot="action" slot-scope="text, record">
          <a-button type="link" class="btn-link" @click="goDetial(record, 1)">
            查看
          </a-button>

          <template v-if="record.state == 0">
            <a-divider type="vertical" />
            <a-button type="link" class="btn-link" @click="add(record.id)">
              修改
            </a-button>
            <a-divider type="vertical" />
            <a-button
              type="link"
              class="btn-link"
              @click="showDeleteConfirm(record.id)"
            >
              删除
            </a-button> </template
          ><a-divider type="vertical" v-if="record.recallButton" />
          <a-button
            v-if="record.recallButton"
            type="link"
            class="btn-link"
            @click="showRecallConfirm(record)"
          >
            撤回
          </a-button>
        </div>
      </a-table>
      <div class="pagination">
        <a-pagination
          :current="page"
          :default-current="page"
          :total="total"
          :pageSize="size"
          @change="pageChange"
        />
      </div>
    </div>
    <appfloor></appfloor>
  </div>
</template>
<script>
const columns = [
  {
    title: '报销单号',
    dataIndex: 'index',
    key: 'index',
    align: 'center',
    // width: 80,
    scopedSlots: { customRender: 'index' }
  },

  {
    title: '申请人',
    dataIndex: 'assetsname',
    key: 'assetsname',

    ellipsis: true,
    align: 'left'
  },
  {
    title: '申请时间',
    dataIndex: 'model',
    key: 'model',
    ellipsis: true
  },
  {
    title: '报销设计总金额（元）',
    dataIndex: 'storage',
    key: 'storage',
    ellipsis: true,
    align: 'left'
  },

  {
    title: '凭证数',
    dataIndex: 'amount',
    key: 'amount',
    ellipsis: true,
    align: 'left'
  },
  {
    title: '报销状态',
    dataIndex: 'disposalstate',
    key: 'disposalstate',
    scopedSlots: { customRender: 'disposalstate' },
    ellipsis: true,
    align: 'left'
  },
  {
    title: '表单状态',
    dataIndex: 'state',
    key: 'state',
    scopedSlots: { customRender: 'state' },
    ellipsis: true,
    align: 'left'
  },

  {
    key: 'operation',
    scopedSlots: { customRender: 'action' },
    title: '操作',
    width: 180,
    align: 'left'
  }
]
// import { getDispositionList, deleteDisposition } from './api/api'

import { recallProcessFn } from '@/utils/utils'
export default {
  data() {
    return {
      expand: false,
      queryForm: {},
      data: [],
      columns,
      page: 1,
      total: 0,
      size: 10,

      loading: false
    }
  },

  mounted() {
    // this.load()
  },
  methods: {
    // 提交 未审批 可撤回流程
    showRecallConfirm(record) {
      const recallProcessPromise = new Promise((resolve, reject) => {
        recallProcessFn(this, record, resolve, reject, 'd-fixe-dasset')
      })
      recallProcessPromise
        .then((value) => {
          console.log(value)
          this.load()
        })
        .catch((error) => {
          console.log(error)
          this.load()
        })
    },
    cancel() {
      //取消
      this.queryForm = {}
    },
    subMit() {
      this.page = 1
      this.load()
    },
    // 拉取列表
    load() {
      this.loading = true
      let params = this.queryForm
      params.page = this.page
      params.size = this.size
      getDispositionList(params).then((res) => {
        this.loading = false
        if (res.data.code == 0) {
          this.data = res.data.data
          this.total = res.data.count
        }
      })
    },
    showDeleteConfirm(id) {
      this.$confirm({
        title: '确定删除吗?',
        okType: 'danger',
        onOk: () => {
          deleteDisposition({ id }).then((res) => {
            if (res.data.code == 0) {
              this.$message.success('删除成功')
              this.page = 1
              this.load()
            }
          })
        }
      })
    },
    add(id) {
      if (id) {
        this.$router.push({
          path: '/HeatingFeeDetail',
          query: {
            id
          }
        })
      } else {
        this.$router.push('/HeatingFeeDetail')
      }
    },
    goDetial(record) {
      this.$router.push('/HeatingFeeDetail?id=' + record.id + '&isEdit=1')
    },
    pageChange(pageber) {
      this.page = pageber
      this.load()
    }
  }
}
</script>
<style lang="scss" scoped>
.search-flex {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  .query-top-select {
    width: calc(100% - 200px);
    .query-cont {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .query-view {
        display: flex;
        align-items: center;
        justify-content: center;
        .query-view-lable {
          width: 75px;
          height: 22px;
          color: rgba(0, 0, 0, 0.65);
          font-size: 14px;
          line-height: 22px;
          text-align: right;
          margin-right: 10px;
        }
      }
    }
  }
  .search-flex-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
}
.search-btns {
  position: relative;
  .statistics {
    position: absolute;
    right: 50px;
    font-size: 14px;
  }
}
.statusDiv {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/views/HeatingFee/myHeatingFee.vue